export default "__VITE_ASSET__D7mO7NFJ__"